import { Emitter } from "@welshman/lib";
import { LOCAL_RELAY_URL } from "@welshman/util";
export class Local extends Emitter {
    relay;
    constructor(relay) {
        super();
        this.relay = relay;
        relay.on("*", this.onMessage);
    }
    get connections() {
        return [];
    }
    async send(...payload) {
        await this.relay.send(...payload);
    }
    onMessage = (...message) => {
        const [verb, ...payload] = message;
        this.emit(verb, LOCAL_RELAY_URL, ...payload);
    };
    cleanup = () => {
        this.removeAllListeners();
        this.relay.off("*", this.onMessage);
    };
}
//# sourceMappingURL=Local.js.map